
/* styles */
require("!!../../../../node_modules/_extract-text-webpack-plugin@1.0.1@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/style-rewriter?id=data-v-0abe844f!less-loader?sourceMap!../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=styles&index=0!./page-assets.vue")

var Component = require("!../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=script&index=0!./page-assets.vue"),
  /* template */
  require("!!../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/template-compiler?id=data-v-0abe844f!../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=template&index=0!./page-assets.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/frontStage/buManage/page-assets.vue
// module id = 651
// module chunks = 1